// src/components/admin/MenuAdmin.js
import React, { useContext } from 'react';
import { PuntosContext } from '../context/PuntosContext';
import { Link, useLocation } from 'react-router-dom';
import './MenuAdmin.css';

const AdminPanel = () => {
  const { hasAdminAccess } = useContext(PuntosContext);
  const location = useLocation();
  const isDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

  if (!hasAdminAccess && !isDev) {
    return null;
  }

  return (
    <>
      <div className="floating-button">
        <label htmlFor="admin-drawer" className="drawer-button" title="Panel de Administración MatiMarket">
          <span className="material-symbols-outlined">admin_panel_settings</span>
        </label>
      </div>
      <div className="drawer">
        <input id="admin-drawer" type="checkbox" className="drawer-toggle" />
        <div className="drawer-content">
          {/* Main content handled by Router */}
        </div>
        <div className="drawer-side z-50">
          <label htmlFor="admin-drawer" className="drawer-overlay"></label>
          <ul className="menu bg-[#151a22] text-gray-200 border border-[#b7f900]/30 rounded-2xl z-50 w-72 p-4 shadow-2xl min-h-80 mt-20 space-y-1">
            <li className="menu-title text-[#b7f900] font-bold tracking-wider text-xs uppercase px-3 py-2 border-b border-gray-800 mb-2">
              Admin Suite MatiMarket
            </li>
            <li>
              <Link to="/admin" className={`flex items-center gap-2 ${location.pathname === '/admin' ? 'active font-bold text-[#b7f900]' : ''}`}>
                <span className="material-symbols-outlined text-sm">dashboard</span>
                Dashboard Resumen
              </Link>
            </li>
            <li>
              <Link to="/admin/usuarios" className={`flex items-center gap-2 ${location.pathname === '/admin/usuarios' ? 'active font-bold text-[#b7f900]' : ''}`}>
                <span className="material-symbols-outlined text-sm">group</span>
                Usuarios
              </Link>
            </li>
            <li>
              <Link to="/admin/productos" className={`flex items-center gap-2 ${location.pathname === '/admin/productos' ? 'active font-bold text-[#b7f900]' : ''}`}>
                <span className="material-symbols-outlined text-sm">inventory_2</span>
                Productos
              </Link>
            </li>
            <li>
              <Link to="/admin/tablas" className={`flex items-center gap-2 ${location.pathname === '/admin/tablas' ? 'active font-bold text-[#b7f900]' : ''}`}>
                <span className="material-symbols-outlined text-sm">table_view</span>
                Explorador Tablas (24)
              </Link>
            </li>
            <li>
              <Link to="/admin/ventas" className={`flex items-center gap-2 ${location.pathname === '/admin/ventas' ? 'active font-bold text-[#b7f900]' : ''}`}>
                <span className="material-symbols-outlined text-sm">point_of_sale</span>
                Ventas & Pagos
              </Link>
            </li>
            <li>
              <Link to="/admin?tab=permisos" className={`flex items-center gap-2 ${location.search.includes('tab=permisos') ? 'active font-bold text-[#b7f900]' : ''}`}>
                <span className="material-symbols-outlined text-sm">security</span>
                Gestor de Permisos
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default AdminPanel;
